export default __webpack_public_path__ + "static/media/gallery_00.07350bd0.jpg";